/**
 * Candor marketing site pages (cloned from Candor-website-Updated-04062026).
 * Public HTML under public/candor-website/ — no login required.
 */
export const CANDOR_WEBSITE_PUBLIC_PATH = '/candor-website';

export const WEBSITE_PAGE_REGISTRY = [
  {
    id: 'home',
    route: '/',
    htmlFile: 'index.html',
    componentName: 'HomePage',
    documentTitle: 'Candor | Home',
  },
  {
    id: 'about',
    route: '/about',
    htmlFile: 'About.html',
    componentName: 'AboutPage',
    documentTitle: 'About Us | Candor',
  },
  {
    id: 'features',
    route: '/features',
    htmlFile: 'Features.html',
    componentName: 'FeaturesPage',
    documentTitle: 'Features | Candor',
  },
  {
    id: 'pricing',
    route: '/pricing',
    htmlFile: 'Pricing.html',
    componentName: 'PricingPage',
    documentTitle: 'Pricing | Candor',
  },
  {
    id: 'security',
    route: '/security',
    htmlFile: 'Security.html',
    componentName: 'SecurityPage',
    documentTitle: 'Security | Candor',
  },
  {
    id: 'blog',
    route: '/blog',
    htmlFile: 'blog.html',
    componentName: 'BlogPage',
    documentTitle: 'Blog | Candor',
  },
  {
    id: 'newsletter',
    route: '/newsletter',
    htmlFile: 'newsletter.html',
    componentName: 'NewsletterPage',
    documentTitle: 'Newsletter | Candor',
  },
  {
    id: 'press-release',
    route: '/press-release',
    htmlFile: 'press-release.html',
    componentName: 'PressReleasePage',
    documentTitle: 'Press Release | Candor',
  },
  {
    id: 'privacy-policy',
    route: '/privacy-policy',
    htmlFile: 'Privacy_Policy.html',
    componentName: 'PrivacyPolicyPage',
    documentTitle: 'Privacy Policy | Candor',
  },
  {
    id: 'terms-conditions',
    route: '/terms-and-policies',
    htmlFile: 'TermsConditions.html',
    componentName: 'TermsConditionsPage',
    documentTitle: 'Terms & Conditions | Candor',
  },
  {
    id: 'refund-policies',
    route: '/refund-policy',
    htmlFile: 'refund_policies.html',
    componentName: 'RefundPoliciesPage',
    documentTitle: 'Refund Policy | Candor',
  },
  {
    id: 'solutions-migrations',
    route: '/solutions/migrations',
    htmlFile: 'solutions_migrations.html',
    componentName: 'MigrationsPage',
    documentTitle: 'Schema-Aware Migration Engine | Candor',
  },
  {
    id: 'download',
    route: '/download',
    htmlFile: 'download.html',
    componentName: 'DownloadPage',
    documentTitle: 'Download Candor SI IDE | Multi-Platform (Windows, Mac, Linux)',
  },
];

/** Map legacy .html filenames to React routes (for in-app navigation helpers). */
export const HTML_FILE_TO_ROUTE = WEBSITE_PAGE_REGISTRY.reduce((acc, page) => {
  acc[page.htmlFile] = page.route;
  acc[page.htmlFile.toLowerCase()] = page.route;
  return acc;
}, {
  'index.html': '/',
  'Terms & Conditions.html': '/terms-and-policies',
  'TermsConditions.html': '/terms-and-policies',
  'download.html': '/download',
});
